'use strict'
import { request } from '../../plugins/http'

export default async (companyId) => {
    return await request.get('/usuario', {params:{companyId:companyId}})
}